export const CANONICAL_TIME_BANDS = [
  {
    key: "morning",
    label: "Morning",
    startTime: "06:00",
    endTime: "12:00",
    rangeLabel: "6:00 AM – 12:00 PM",
  },
  {
    key: "offpeak",
    label: "Afternoon",
    startTime: "12:00",
    endTime: "17:00",
    rangeLabel: "12:00 PM – 5:00 PM",
  },
  {
    key: "evening",
    label: "Evening",
    startTime: "17:00",
    endTime: "23:00",
    rangeLabel: "5:00 PM – 11:00 PM",
  },
  {
    key: "overnight",
    label: "Overnight",
    startTime: "23:00",
    endTime: "06:00",
    rangeLabel: "11:00 PM – 6:00 AM (next day)",
  },
] as const;

export type CanonicalTimeBandKey = (typeof CANONICAL_TIME_BANDS)[number]["key"];

export function findCanonicalTimeBandByKey(value: unknown) {
  return CANONICAL_TIME_BANDS.find((band) => band.key === value);
}

export function findPersistedCanonicalTimeBand(value: any) {
  const band = findCanonicalTimeBandByKey(value?.timeBand);
  if (!band) return undefined;
  const startMatches =
    value?.startTime === undefined || value.startTime === band.startTime;
  const endMatches =
    value?.endTime === undefined || value.endTime === band.endTime;
  return startMatches && endMatches ? band : undefined;
}
